export const homeURL = "/";
export const aboutUsURL = "/about-us";
export const termsandconditionURL = "/terms-and-conditions";
export const privacypolicyURL = "/privacy-policy";
export const contactUsURL = "/contact-us";
export const reflectionsURL = "/reflections";
export const reflectionsInnerURL = "/reflections/:slug";
export const interviewsURL = "/interviews";
export const faqsURL = "/faqs";
